<template>
  <SntSelect
    :width="width"
    :value="value"
    :items="filteredItems"
    :loading="$apollo.loading"
    :has-next-page="customerCategoryList.hasNextPage"
    :callback="fetchMore"
    :placeholder="placeholder"
    :clearable="clearable"
    :disabled="disabled"
    :item-value="itemValue"
    :hide-details="hideDetails"
    item-text="name"
    @input="$emit('input', $event)" />
</template>

<script>
import { GET_CUSTOMER_CATEGORY } from '@/resources/graphql'
import SntSelect from '@/components/form/SntSelect.vue'

export default {
  components: {
    SntSelect
  },
  props: {
    value: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: '-'
    },
    width: {
      type: String,
      default: '374px'
    },
    ignoreValues: {
      type: Array,
      default: () => []
    },
    hideDetails: Boolean,
    defaultFirstValue: Boolean,
    clearable: Boolean,
    disabled: Boolean,
    nullable: Boolean
  },
  apollo: {
    customerCategoryList: {
      query: GET_CUSTOMER_CATEGORY,
      variables () {
        return {
          page: 1,
          perPage: this.perPage
        }
      },
      update ({ customerCategoryList }) {
        if (this.nullable) {
          return {
            ...customerCategoryList,
            nodes: this.$_.concat(
              [
                {
                  id: null,
                  name: '-'
                }
              ],
              customerCategoryList.nodes
            )
          }
        }
        return customerCategoryList
      },
      result ({ data }) {
        this.onLoaded(data)
        this.selectDefaultFirstValue()
      }
    }
  },
  data () {
    return {
      page: 1,
      perPage: 20,
      itemValue: 'id',
      customerCategoryList: {
        nodes: [],
        hasNextPage: false
      }
    }
  },
  computed: {
    filteredItems () {
      let items = this.customerCategoryList.nodes
      if (this.ignoreValues?.length) {
        items = items.filter(
          (item) => !this.ignoreValues?.includes(item[this.itemValue])
        )
      }
      return items
    }
  },
  watch: {
    ignoreValues () {
      this.selectDefaultFirstValue()
    }
  },
  methods: {
    fetchMore () {
      this.page += 1
      return this.$apollo.queries.customerCategoryList.fetchMore({
        variables: {
          page: this.page,
          perPage: this.perPage
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          const { hasNextPage, nodes } = fetchMoreResult.customerCategoryList
          return {
            customerCategoryList: {
              __typename: previousResult.customerCategoryList.__typename,
              nodes: this.$_.uniqBy(
                [...previousResult.customerCategoryList.nodes, ...nodes],
                this.itemValue
              ),
              hasNextPage
            }
          }
        }
      })
    },
    selectDefaultFirstValue () {
      if (this.defaultFirstValue && !this.value) {
        const item = this.$_.head(this.filteredItems)
        if (item) {
          this.$emit('input', item[this.itemValue])
        }
      }
    },
    onLoaded (data) {
      this.$emit('loaded', data)
    }
  }
}
</script>
